import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const messages = {
    //英文
    en: {
        m: {
            nav_center_text: 'Open your maintenance trip',
            return_home:'home',
            index_title_1:'We need to know about your cell phone',
            next:'Next step',
            phone_info:'Phone info',
            phone_problem:'phone problem',
            home:'home',
            about_us:'about us',
            service_intro:'Service Intro',
            contact_us:'contact us',
            The_largest :'The largest mobile phone repair platform in North America',
            North_America :'North America Internet\'s only designated all-round mobile phone repair service platform',
            Start_repair :'Start repair',
            our_service :'our service',
            com :'Shenzhen Meichefu Network Technology Co., Ltd.',
            Screen_replacement :'Screen replace',
            operating_hours :'operating hours',
            Memory_upgrade :'Memory upgrade',
            Support :'Support iphone\\Android and other mobile phone screen problems.',
            Battery_replacement :'Battery replace',
            Can_not_boot :'Can not boot',
            Main_board_water :'Main board water',
            North_American :'North American XXX Technology Co., Ltd., founded in 2009 by founder XXX, is mainly engaged in offline mobile phone repair and sales. With a keen market sense, we are firmly grasping the needs of users and have established a foothold in the digital industry in a short period of time.',
            Price_transparency:'Price transparency',
            Quality_assurance:'Quality assurance',
            Efficient_maintenance:'Efficient maintenance',
            after_sale_warranty:'after-sale warranty',
            service_line:'service line',
            your_location:'your location',
            Appointment:'Appointment',
            Pay:'Payment',
            Payment_completed:'Payment fulfil',
            select_brand:'Please select phone brand',
            select_model:'Please select phone model',
            select_color:'Please select phone color',
            What_is:'What is wrong with your phone?',
            Black_screen:'Black screen',
            Broken_screen:'Broken screen',
            not_durable:'Battery is not durable',
            Not_charging:'Not charging',
            To_upgrade_memory:'To upgrade memory',
            Button_not_pressed:'Button can not be pressed',
            We_want:'We want to arrange the nearest repair point for you.',
            An_engineer:'Reservations are available during the following hours',
            select_date:'Please select an appointment date',
            NoData:'No data',
            TheOrder:'The order takes effect after the payment is completed',
            phoneSituation:'phone situation',
            RepairPoint:'Repair point',
            paymentMethod:'payment method',
            TheRepair:'The repair item is estimated to be paid',
            ReturnModif:'Return modification',
            OrderCenter:'Order center',
            All:'All',
            To_be_paid:'To be paid',
            Already_reserved:'Already reserved',
            in_maintenance:'in maintenance',
            Repair_completed:'Repair completed',
            Cancelled:'Cancelled',
            Order_completed:'Order completed',
            order_number:'order number',
            Appointment_to_shop_time:'Appointment time',
            Paid:'Paid',
            payment_successful:'payment successful',
            schedule_to_your_email:'schedule to your email',
            Please_login:'Please login to this site first, let us better serve',
            Please_arrive:'Please arrive at',
            Order_management:'Order manage',
            quit:'quit',
            Welcome_log_in:'Welcome to log in',
            log_in:'login',
            register:'register',
            select_address:'Click to select address',
            Email_incorrect:'E-mail format is incorrect',
            Password_incorrect:'Password length is incorrect',
            email:'email',
            password:'password',
            forget_password:'forget password?',
            User_registration:'User registration',
            Two_passwords_inconsistent:'Two passwords are inconsistent',
            User_name_inconsistent:'User name length is incorrect',
            username:'username',
            repeatPassword:'Please re-enter password',
            address:'address',
            No_order:'No order',
            Immediate_registration:'Immediate registration',
            Sign_in_with:'Sign in with',
        }
    },
    //简体中文
    zh: {
        m: {
            nav_center_text: '开启您的维修之旅',
            return_home:'返回首页',
            index_title_1:'我们需要知道您手机的情况',
            next:'下一步',
            phone_info:' 手机信息',
            phone_problem:'手机问题',
            home:'首页',
            about_us:'关于我们',
            service_intro:'服务介绍',
            contact_us:'联系我们',
            The_largest:'全北美最大手机维修平台',
            North_America:'北美互联网唯一指定全方位手机维修服务平台',
            Start_repair :'开始维修',
            our_service :'我们的服务',
            com :'深圳市美车夫网络科技有限公司',
            Screen_replacement :'屏幕更换',
            operating_hours :'工作时间',
            Memory_upgrade :'内存升级',
            Support :'支持iphone\\安卓等手机屏幕问题，我们有600项配件支持更换',
            Battery_replacement :'电池更换',
            Can_not_boot :'无法开机',
            Main_board_water :'主板进水',
            North_American :'北美XXX科技有限公司，于2009年由创始人XXX创立，主营线下手机维修及销售。凭借敏锐的市场嗅觉，紧抓用户需求点，在短短时间内便在数码行业站稳了脚。',
            Price_transparency:'价格透明',
            Quality_assurance:'质量保证',
            Efficient_maintenance:'高效维修',
            after_sale_warranty:'售后保障',
            service_line:'服务电话',
            your_location:'您的位置',
            Appointment:' 预约时间',
            Pay:' 支付',
            Payment_completed:' 支付完成',
            select_brand:'请选择手机品牌',
            select_model:'请选择手机型号',
            select_color:'请选择手机品牌',
            What_is:'您的手机大概存在什么问题？',
            Black_screen:'黑屏',
            Broken_screen:'碎屏',
            not_durable:'电池不耐用',
            Not_charging:'充不上电',
            To_upgrade_memory:'要升级内存',
            Button_not_pressed:'按键按不动',
            We_want:'我们想为你安排最近的维修点',
            An_engineer:'已为您安排工程师，以下时段可预约',
            select_date:'请选择预约日期',
            NoData:'暂无数据',
            TheOrder:'支付完成后订单生效',
            phoneSituation:'手机情况',
            RepairPoint:'维修点',
            paymentMethod:'支付方式',
            TheRepair:'该维修项预估需要支付费用',
            ReturnModif:'返回修改',
            OrderCenter:'订单中心',
            All:'全部',
            To_be_paid:'待支付',
            Already_reserved:'已预约',
            in_maintenance:'维修中',
            Repair_completed:'维修完成',
            Cancelled:'已取消',
            Order_completed:'订单完成',
            order_number:'订单号',
            Appointment_to_shop_time:'预约到店时间',
            Paid:'已支付',
            payment_successful:'支付成功',
            schedule_to_your_email:'我们已将日程安排发送到您的邮箱',
            Please_login:'请先登录本站，让我们更好的服务',
            Order_management:'订单管理',
            quit:'退出',
            Welcome_log_in:'欢迎登录',
            log_in:'登录',
            register:'注册',
            select_address:'点击选择地址',
            Email_incorrect:'邮箱格式不正确',
            Password_incorrect:'密码长度不正确',
            email:'邮箱',
            password:'密码',
            forget_password:'忘记密码？',
            User_registration:'用户注册',
            Two_passwords_inconsistent:'两次密码不一致',
            User_name_inconsistent:'用户名长度不正确',
            username:'用户名',
            repeatPassword:'重新输入密码',
            address:'地址',
            No_order:'暂无订单',
            Immediate_registration:'立即注册',
            Sign_in_with:'第三方登录',
        }
    }
}




const i18n = new VueI18n({
    //定义默认语言
    locale: 'en',
    // locale: 'zh',
    messages
})
export default i18n